export default __webpack_public_path__ + "media/images/jvqmap/background-9b3430aa7ef1879c9aac6d146449bc82.png";